import React, { useEffect, useState } from "react";
import { useLang } from "@/i18n/LanguageContext";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/ueevhrtz_ChatGPT%20Image%2015%20%D0%B8%D1%8E%D0%BD.%202026%20%D0%B3.%2C%2011_31_42.png";

const Hero = () => {
  const { t } = useLang();
  const [mouse, setMouse] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const onMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 8;
      const y = (e.clientY / window.innerHeight - 0.5) * 8;
      setMouse({ x, y });
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, []);

  return (
    <section
      data-testid="hero-section"
      id="top"
      className="relative min-h-[100vh] flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 z-0"
        style={{
          transform: `translate(${mouse.x * 0.4}px, ${mouse.y * 0.4}px) scale(1.05)`,
          transition: "transform 0.6s ease-out",
        }}
      >
        <img
          src={HERO_IMG}
          alt="Castel Construct — câmp de turbine eoliene"
          className="w-full h-full object-cover"
          data-testid="hero-bg"
        />
        {/* Soft overlay for text legibility */}
        <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/70 to-white/20" />
        <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-transparent to-white/60" />
      </div>

      {/* Content */}
      <div className="container-page relative z-10 py-32 md:py-40 w-full">
        <div className="max-w-3xl">
          <div
            className="flex items-center gap-3 text-xs font-mono uppercase tracking-[0.18em] text-neutral-700 mb-8 fade-up"
            data-testid="hero-eyebrow"
          >
            <span className="w-8 h-px bg-neutral-500" />
            {t.hero.eyebrow}
          </div>

          <h1
            data-testid="hero-title"
            className="font-display text-[clamp(3rem,8vw,7.5rem)] leading-[0.95] tracking-[-0.03em] text-black fade-up"
            style={{ animationDelay: "0.1s" }}
          >
            {t.hero.titleA}{" "}
            <span className="italic text-[var(--accent)]">{t.hero.titleB}</span>{" "}
            {t.hero.titleC}
          </h1>

          <p
            data-testid="hero-lead"
            className="mt-8 max-w-xl text-lg md:text-xl text-neutral-700 leading-relaxed fade-up"
            style={{ animationDelay: "0.25s" }}
          >
            {t.hero.lead}
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4 fade-up" style={{ animationDelay: "0.4s" }}>
            <a
              href="#contact"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center gap-3 bg-black text-white px-7 py-4 hover:bg-[var(--accent)] transition-colors"
            >
              <span>{t.hero.ctaPrimary}</span>
              <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
            </a>
            <a
              href="#services"
              data-testid="hero-cta-secondary"
              className="group inline-flex items-center gap-3 px-7 py-4 border border-black/30 bg-white/40 backdrop-blur-sm hover:border-black hover:bg-white/80 transition-colors"
            >
              <span>{t.hero.ctaSecondary}</span>
              <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
